export default __webpack_public_path__ + "static/subset-UniNeueThin-Italic-fada0604fe7596b0608a50ce325417b4.woff2";